import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "danh-muc-vat-tu-search-autocomplete-status"
}
const _hoisted_2 = { key: 1 }

import { ref, watch, nextTick } from 'vue';
import type { ElAutocomplete } from 'element-plus';
import { swalErrNotification } from '@/core/helpers/utils';
import DanhMucVatTuService from '@/core/services/DanhMucVatTu.service';
import { IDanhMucVatTuResponseBase } from '@/core/interfaces/ApiResponses';

type SuggestionItem = IDanhMucVatTuResponseBase & {
  __loading?: boolean;
  __empty?: boolean;
};

type AutocompleteInstance = InstanceType<typeof ElAutocomplete> & {
  activated: boolean;
  suggestionDisabled: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DanhMucVatTuSearchInput',
  props: {
  id: {
    type: Number as () => number | null,
    default: null,
  },
  displayLabel: {
    type: String,
    default: '',
  },
},
  emits: ["clear", "select"],
  setup(__props, { emit: __emit }) {

const LOADING_SUGGESTION: SuggestionItem = {
  __loading: true,
  id: -1,
  ten_danh_muc: 'Đang tìm kiếm....',
  ma_danh_muc: '',
} as SuggestionItem;

const EMPTY_SUGGESTION: SuggestionItem = {
  __empty: true,
  id: -2,
  ten_danh_muc: 'Không có kết quả',
  ma_danh_muc: '',
} as SuggestionItem;

const props = __props;

const tenDanhMuc = ref<string>(props.displayLabel);
const selectedId = ref<number | null>(props.id);
const autocompleteRef = ref<AutocompleteInstance>();

watch(
  () => props.displayLabel,
  (label) => {
    if (label) {
      tenDanhMuc.value = label;

      return;
    }

    if (!props.id) {
      tenDanhMuc.value = '';
    }
  },
  { immediate: true },
);

watch(() => props.id, async (newId, previousId) => {
  if (!newId) {
    if (!props.displayLabel) {
      tenDanhMuc.value = '';
    }

    selectedId.value = null;

    return;
  }

  selectedId.value = newId;

  if (props.displayLabel || (previousId && previousId === newId)) {
    return;
  }

  try {
    const {
      data: {
        data: {
          ten_danh_muc,
        },
      },
    } = await DanhMucVatTuService.get(newId);

    tenDanhMuc.value = ten_danh_muc;
  } catch (error) {
    await swalErrNotification(error, 'Có lỗi xảy ra');
  }
});

const emits = __emit;

const isStatusSuggestion = (item: SuggestionItem) => item.__loading || item.__empty;

const handleOptionSelected = (item: SuggestionItem) => {
  if (isStatusSuggestion(item)) {
    return;
  }

  selectedId.value = item.id;
  tenDanhMuc.value = item.ten_danh_muc;
  emits('select', {
    id: item.id,
    ten_danh_muc: item.ten_danh_muc,
    ma_danh_muc: item.ma_danh_muc,
  });
};

const reopenSuggestionsAfterClear = () => {
  nextTick(() => {
    const autocomplete = autocompleteRef.value;

    if (!autocomplete) {
      return;
    }

    autocomplete.suggestionDisabled = false;
    autocomplete.activated = true;
    autocomplete.getData('');
    autocomplete.focus();
  });
};

const handleClear = () => {
  selectedId.value = null;
  tenDanhMuc.value = '';
  emits('clear');
  reopenSuggestionsAfterClear();
};

const query = async (
  queryString: string,
  cb: (results: SuggestionItem[]) => void,
) => {
  cb([LOADING_SUGGESTION]);

  try {
    const {
      data: {
        data: {
          data,
        },
      },
    } = await DanhMucVatTuService.list(1, 200, queryString);

    if (!data?.length) {
      cb([EMPTY_SUGGESTION]);

      return;
    }

    cb(data);
  } catch (error) {
    await swalErrNotification(error, 'Có lỗi xảy ra');
    cb([EMPTY_SUGGESTION]);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createBlock(_component_el_autocomplete, {
    ref_key: "autocompleteRef",
    ref: autocompleteRef,
    modelValue: tenDanhMuc.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenDanhMuc).value = $event)),
    class: "w-full",
    clearable: "",
    "hide-loading": "",
    "fetch-suggestions": query,
    "highlight-first-item": "",
    placeholder: "Nhập để tìm kiếm",
    "popper-class": "danh-muc-vat-tu-search-autocomplete-popper",
    "trigger-on-focus": true,
    onClear: handleClear,
    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select())),
    onSelect: handleOptionSelected
  }, {
    default: _withCtx(({ item }) => [
      (item.__loading || item.__empty)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.ten_danh_muc), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.ten_danh_muc), 1))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})